import { useEffect } from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes, useNavigate } from 'react-router-dom';
import { setOn401Handler } from '@/lib/api';
import { AppLayout } from '@/components/Layout';
import { RequireAuth } from '@/components/RequireAuth';
import { CostPage } from '@/pages/Cost';
import { ChannelsPage } from '@/pages/Channels';
import { DashboardPage } from '@/pages/Dashboard';
import { EventsPage } from '@/pages/Events';
import { LoginPage } from '@/pages/Login';
import { LogsPage } from '@/pages/Logs';
import { PricingPage } from '@/pages/Pricing';
import { PricingHistoryPage } from '@/pages/PricingHistory';
import { RoutesPage } from '@/pages/Routes';
import { SettingsPage } from '@/pages/Settings';
import { SeatsPage } from '@/pages/Seats';
import { UsersPage } from '@/pages/Users';

function On401Setup() {
  const navigate = useNavigate();
  useEffect(() => {
    // Dev: don't redirect on 401 — lets pricing-calculator UI be inspected
    // without a live backend / valid session cookie.
    if (import.meta.env.DEV) return;
    setOn401Handler(() => {
      if (!window.location.pathname.startsWith('/login')) {
        const next = encodeURIComponent(window.location.pathname + window.location.search);
        navigate(`/login?next=${next}`, { replace: true });
      }
    });
    return () => setOn401Handler(null);
  }, [navigate]);
  return null;
}

export function App() {
  return (
    <Router>
      <On401Setup />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          element={
            <RequireAuth>
              <AppLayout />
            </RequireAuth>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="channels" element={<ChannelsPage />} />
          <Route path="seats" element={<SeatsPage />} />
          <Route path="pricing" element={<PricingPage />} />
          <Route path="pricing-history" element={<PricingHistoryPage />} />
          <Route path="cost" element={<CostPage />} />
          <Route path="events" element={<EventsPage />} />
          <Route path="routes" element={<RoutesPage />} />
          <Route path="logs" element={<LogsPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}
